<!--
일괄기능-입고
------------------------------------

-->
<template>
<div class="">
    
    <!-- 버튼영역 -->
    <div class="uk-text-left">        
        <button 
            class="uk-button uk-button-danger"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.remove.jobInit()"
        >
            <i class="material-icons">delete</i>
            <span class="uk-text-middle">삭제</span>
        </button>
    </div>
    
    <!-- remove 기능 -->
    <remove
        ref="remove"
        :batch="batch"
        :csrfToken="csrfToken"
    ></remove>
    
</div>
    
</template>

<script>
    export default {
        components: {
            'remove': require('./remove.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>